<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  fetchTypologySizes(typologyId) {
    return axios.get(`tipologias/${typologyId}/typology_sizes_for_tax`, AS.getDefaultHeaders());
  },
  createTypologySize(typologyId, typologySizeParams) {
    return axios.post(`tipologias/${typologyId}/typology_sizes_for_tax`,
      { typology_size: typologySizeParams },
      AS.getDefaultHeaders());
  },
  updateTypologySize(typologyId, params) {
    return axios.patch(`tipologias/${typologyId}/typology_sizes_for_tax/${params.id}`,
      { typology_size: params }, AS.getDefaultHeaders());
  },
};
</script>
